import { Box, Button, Paper, Typography } from '@mui/material';
import React, { useEffect, useState, useRef } from 'react';
import UTurnLeftIcon from '@mui/icons-material/UTurnLeft';

import Grid from '@mui/material/Grid2';
import { useNavigate, useParams } from 'react-router-dom';
import { useStore } from '../../utils/store';
import Constants from '../../utils/constants';
import HttpServices from '../../services/HttpService';
import SimpleDialogComponent from '../../components/SimpleDialogComponent';

import { useSearch } from '../../components/searchContext';
import AlertMessageComponent from '../../components/AlertMessageComponent';
import { useAlert } from '../../components/alertContext';
import CustomPaginationActionsTable from '../../components/TablePagination';
import TextFieldComponent from '../../components/form/TextFieldComponent';
import AddButtonComponent from '../../components/form/AddButtonComponent';
import ButtonComponent from '../../components/form/ButtonComponent';
import { SortDirection } from '@mui/material';
const ReceiptingDetails: React.FC = () => {
  const isInitialLoad = useRef(true);
  const { searchQuery } = useSearch();
  const { currentId } = useParams<{ currentId: any }>();
  const [currentRecord, setCurrentRecord] = useState<any>(null);
  const [rows, setRows] = useState<any[]>([]);
  const { alert, setAlert, handleCloseAlert } = useAlert();
  const [inProgressSend, setInProgressSend] = useState<boolean>(false);
  const [confirmDailogOpen, setConfirmDailogOpen] = useState<boolean>(false);
  const { getAdmin } = useStore();
  const navigate = useNavigate();
  const [orderBy, setOrderBy] = useState<any>('id');
  const [order, setOrder] = useState<SortDirection>('asc');
  const handleOrderBy = (orderByColumn: any) => {
    setOrderBy(orderByColumn);
    // console.log(order);
    // console.log(orderByColumn);
    if (order === 'desc') {
      setOrder('asc');
      return;
    } else {
      setOrder('desc');
      return;
    }
  };

  useEffect(() => {
    if (isInitialLoad.current) {
      if (currentId) {
        if (parseInt(currentId) > 0) {
          fetchOrderDetails(currentId);
        }
      } else {
        setCurrentRecord(null);
      }

      isInitialLoad.current = false;
    }
  }, [currentId]);
  const columns: any[] = [
    {
      field: 'srcName',
      headerName: 'Location',
    },
    {
      field: 'resourceName',
      headerName: 'Resource Items',
    },
    {
      field: 'quantityOrdered',
      headerName: 'Qty to Despatch',
    },

    {
      field: 'quantityReceived',
      headerName: 'Goods Received',
      renderCell: (value: any, row: any) => (
        <Box sx={{ width: 100 }}>
          {currentRecord.orderStatus !== 'completed' ? (
            <TextFieldComponent
              errorStr=""
              type="number"
              isRequired={false}
              keyName={row.resourceId + '_POOrderQty'}
              label=""
              name={row.resourceId + '_POOrderQty'}
              value={value === undefined ? '' : value}
              onChange={(event: any) => {
                const currentIndex = rows.findIndex(
                  (item) =>
                    item.inventoryOrderItemId === row.inventoryOrderItemId
                );
                //  console.log(transferList[currentIndex], '-------');
                setRows((prevItems) => {
                  const updatedItems = [...prevItems];
                  if (currentIndex !== -1) {
                    updatedItems[currentIndex]['quantityReceived'] =
                      event.target.value;
                  }
                  return updatedItems;
                });
              }}
            />
          ) : (
            value
          )}
        </Box>
      ),
    },
  ];
  const fetchOrderDetails = async (currentId: any) => {
    try {
      const response = await HttpServices.get(
        `${Constants.apiURL + Constants.inventoryURL}/orders/${currentId}`,
        { headers: { Authorization: `Bearer ${getAdmin()}` } },
        {}
      );
      //console.log(response);
      if (response.data) {
        setCurrentRecord(response.data);
        setRows(response.data.items);
        handleOrderBy('id');
        return true;
      } else {
        return false;
      }
    } catch (error: any) {
      console.error(`Error fetching data:`, error);
      return false;
    }
  };
  const dialogConfirmation = () => {
    return (
      <Box sx={{ width: '450px' }}>
        <h2>Are you sure you want to Finalize items?</h2>
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            gap: '20px',
          }}
        >
          <ButtonComponent
            errors={[]}
            keyName="okbuttonconfirm"
            label={'Confirm'}
            onClick={async () => {
              handleOrder('completed');
              setConfirmDailogOpen(false);
            }}
          />
        </Box>
      </Box>
    );
  };
  const handleOrder = async (type: string) => {
    try {
      const items: any[] = rows
        .filter(
          (item: any) =>
            item.quantityReceived !== undefined && item.quantityReceived !== ''
        )
        .map((item: any) => ({
          inventoryOrderItemId: item.inventoryOrderItemId,
          quantityReceived: item.quantityReceived,
        }));
      if (items.length === 0) {
        setAlert({
          type: 'error',
          message: 'atleast one quantity is required',
          open: true,
        });
        return false;
      }

      setInProgressSend(true);

      const postData = {
        inventoryOrderId: currentId,
        orderStatus: type,
        items: items,
      };
      const endpoint = `${Constants.apiURL + Constants.inventoryURL}/orders`;
      const response = await HttpServices.put(endpoint, postData, {
        headers: { Authorization: `Bearer ${getAdmin()}` },
      });
      if (response.success) {
        setAlert({
          type: 'success',
          open: true,
          message: 'Saved Successfully',
        });
        navigate('/inventory/material-transfer-po');
      }
    } catch (e: any) {
      setAlert({
        type: 'error',
        open: true,
        message: e.message,
      });
    }
    let errorMessage = '';
    return errorMessage;
  };
  return (
    <Box className="main dashboardmain">
      <section className="section dashboard">
        <div className="containergrid">
          <div className="mt-2">
            <div
              onClick={() => {
                navigate('/inventory/material-transfer-po');
              }}
              style={{
                cursor: 'pointer',
                display: 'inline-flex',
                gap: '8px',
                alignItems: 'center',
                marginBottom: '16px',
              }}
            >
              <UTurnLeftIcon
                sx={{
                  transform: 'rotate(90deg)',
                  cursor: 'pointer',
                }}
              />
              <Typography>Back</Typography>
            </div>
            <Typography variant="h6" sx={{ m: 2 }}>
              Receipting Details
            </Typography>
            <Paper sx={{ width: '100%' }} className="mt-4">
              <Box
                sx={{
                  padding: '24px 16px 16px 16px',
                  mb: 2,
                  display: 'grid',
                  gap: '32px',
                  overflowX: 'scroll',
                }}
              >
                {currentRecord && (
                  <Box
                    sx={{
                      backgroundColor: '#F9F9F9',
                      border: '1px solid #EFEEED',
                      borderRadius: '6px',
                      padding: ' 16px',
                    }}
                  >
                    <Grid container spacing={2}>
                      <Grid size={4}>
                        <h3 className="ovreview-label">Transfer / PO Number</h3>
                        {currentRecord.purchaseOrderNumber}
                      </Grid>

                      <Grid size={4}>
                        <h3 className="ovreview-label">{'Source'}</h3>
                        {currentRecord.srcName}
                      </Grid>
                      <Grid size={4}>
                        <h3 className="ovreview-label">
                          {'Delivery Location'}
                        </h3>
                        {currentRecord.destName}
                      </Grid>
                    </Grid>
                  </Box>
                )}
              </Box>
              <Box
                sx={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  padding: '10px',
                  mb: 2,
                }}
              >
                <Typography variant="h6">All Items</Typography>
                {currentRecord && currentRecord.orderStatus !== 'completed' && (
                  <Box sx={{ display: 'flex', gap: 2 }}>
                    <ButtonComponent
                      onClick={() => {
                        setConfirmDailogOpen(true);
                      }}
                      keyName="quoteaddicon"
                      label="Finalise"
                    />

                    <ButtonComponent
                      onClick={() => {
                        handleOrder('pending');
                      }}
                      keyName="quoteaddicon"
                      label="Save & Close"
                    />
                  </Box>
                )}
              </Box>

              <CustomPaginationActionsTable
                rows={rows}
                columns={columns}
                totalRecords={rows.length}
                handlePagination={() => {}}
                isPagingHide={true}
                handleRowClick={(row: any) => {}}
                handleStatus={() => {}}
                order={order}
                orderBy={orderBy}
                handleOrderBy={handleOrderBy}
                paginationModel={{
                  page: 0,
                  pageSize: 25,
                }}
              />
            </Paper>
          </div>
        </div>
      </section>
      <SimpleDialogComponent
        title={'Confirmation'}
        dialogContent={dialogConfirmation()}
        open={confirmDailogOpen}
        handleClose={() => {
          setConfirmDailogOpen(false);
        }}
      />
      <AlertMessageComponent
        type={alert.type}
        open={alert.open}
        handleClose={handleCloseAlert}
        message={alert.message}
      />
    </Box>
  );
};

export default ReceiptingDetails;
